import { WithStyles, withStyles } from '@mui/styles';

import { FirmHistory } from './firmHistory';
import { muiStyles } from './styles';

export interface FirmHistoryProps extends WithStyles<typeof muiStyles>{
}

export default withStyles(muiStyles)(FirmHistory);